export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";